module.exports = __webpack_public_path__ + "img/fig11.22fb64fa.jpg";